/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { useState } from 'react';
import { useOktaAuth, LoginCallback as OktaLoginCallback } from '@okta/okta-react';
import { Switch, Route } from 'react-router-dom';
import { setCookie, getCookie } from 'typescript-monorepo-base';

const AppRoutes = () => {
  const { oktaAuth, authState } = useOktaAuth();

  let oktaCookie = localStorage.getItem('okta-token-storage');    
  console.log('(Routes.tsx): tokenCookie: ', JSON.parse(oktaCookie!));
  let accessToken = oktaCookie ? JSON.parse(oktaCookie).accessToken.accessToken : null;
  console.log('(Routes.tsx): accessToken: ', accessToken);


  let originalUri = localStorage.getItem('original_uri');
  if (originalUri && originalUri.length <= 0) {
    console.error('(Routes.tsx): Missing originalUrl in localStorage');
  }


  if (authState && authState.isAuthenticated) {

    console.log('(Routes.tsx): LOGGED IN! ORIGINAL_URL: ', originalUri);
    
    const targetUrl = window.location.protocol + '//' + window.location.host + originalUri;
    console.log('(Routes.tsx): NavigateTo: ', targetUrl);

    return window.location.assign(targetUrl) as any;

  } else if (authState && !authState.isAuthenticated) {
    console.log('(Routes.tsx): REDIRECTING TO LOGIN');
    //setTimeout(() => {
      oktaAuth.signInWithRedirect();
    //}, 100);

  }
  return (
    <Switch>
      <Route
        path="/okta/"
        component={() => {
          return <OktaLoginCallback />; 
        }}
      />
    </Switch>
  );
};

export default AppRoutes;

